<template>
  <el-header>
    <header class="header-global" v-if="loggedIn" v-loading="loading">
      <ChatInternal ref="chat" :socket="socket" :username="username" :userId="userId"
        v-if="userType == '1' || userType == '3'" />
      <Chat v-else ref="chat" :socket="socket" :username="username" :userId="userId" />
      <MessageHighlight ref="messageHighlight" />
      <AppHeaderMenu @chat="chat" />
    </header>
  </el-header>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import { UserService } from "@/services/users/user.services";
import io from 'socket.io-client';
import { mapActions, mapGetters } from "vuex";
import { TokenService } from '../services/auth/storage.services';
import Chat from "../xpost/components/chat/Chat";
import ChatInternal from "../xpost/components/chat/ChatInternal";
import MessageHighlight from "../xpost/views/comum/notification/message/MessageHighlight";
import AppHeaderMenu from "./components/AppHeaderMenu.vue";
import TruckIcon from './components/TruckIcon';

export default {
  components: { MessageHighlight, Chat, ChatInternal, TruckIcon, AppHeaderMenu },

  data() {
    return {
      loading: false,
      menu: {
        register: [],
        search: [],
        services: [],
        reports: [],
        financial: [],
        licence: [],
      },
      truck: false,
      department: '',
      alert: false,
      socket: null,
      username: "",
      userType: "2",
      userId: "",
      activeIndex2: "0",
      type: "1",
      total: 0,
      operator: 0,
      notifications: [],
      message: "",
    };
  },
  created() {
    const vm = this;
    vm.socket = io('/', {
      path: '/mysocket',
      transports: ['websocket'],
      rejectUnauthorized: false,
      autoConnect: false,
      query: 'token=' + TokenService.getToken(),

    });
    vm.socket.connect();
    vm.setup();
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("menu", ["save"]),
    ...mapActions("socket", ["saveSocket"]),
    setup() {
      const vm = this;
      vm.socket.emit('chat-join');
      this.saveSocket(vm.socket);
      vm.socket.on("newMessage", (data) => {
        vm.notifications.push({
          action: 'newMessage',
          data: data,
        });
        if (this.$route.name === 'home') vm.open();
        vm.message = data;
        vm.alert = true;
        vm.total += 1;
      });
      vm.socket.on("payment-done", (data) => {
        vm.$bus.$emit("payment.done", data);
      });
      vm.socket.on("chat-operator", (data) => {
        vm.operator = data.length;
        vm.$refs.chat.received('operator', data);
      });
      vm.socket.on("chat-operator-message", (data) => {
        for (const messageData of data) {
          vm.$refs.chat.received('message', messageData);
        }
      });
      vm.socket.on("chat-operator-assign", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Atendente ${data} conectado`,
        }, true);
      })
      vm.socket.on("chat-closed", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Chat encerrado`,
        }, false);
      })
      vm.socket.on("chat-transfer", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Chat transferido outro departamento`,
        }, false);
      })
      vm.socket.on("chat-queue-ready", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Sua posição na fila é ${data}`,
        }, false);
      })
      vm.socket.on("chatMessage", (data) => {
        vm.$refs.chat.received('message', data);
      });
      vm.socket.on("chat-populate", (data) => {
        vm.operator = data.length;
        vm.$refs.chat.clear();
        for (const messageData of data) {
          vm.$refs.chat.received('message', messageData);
        }
      });
      vm.socket.on("chat-disconnected", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Usuário desconectado do sistema`,
        }, false);
      });
      vm.socket.open((data) => {
      });
      vm.socket.on("connect", (data) => {
        vm.socket.emit('chat-get-not-read', vm.userId)
      });
      vm.socket.on("disconnect", (data) => {
        this.socket.emit('chat-disconnect', vm.userId);
      });
      vm.socket.on("error", (data) => {
        vm.$message({
          type: "error",
          message: data,
        });
      });
    },
    goto() {
      this.alert = false;
      this.$router.replace({ name: 'notification', params: { to: 'message' } }).catch(() => { });
    },
    chat() {
      const vm = this;
      this.$refs.chat.open()
    },
    me: function () {
      const vm = this;
      vm.loading = true;
      UserService.menu()
        .then((response) => {
          vm.loading = false;
          vm.menu = {
            register: [],
            search: [],
            services: [],
            reports: [],
            financial: [],
            licence: [],
          };
          for (const menu of response) {
            if (menu.father) {
              vm.menu[menu.father].push(menu);
            } else if (menu.menu) {
              vm.menu[menu.menu] = true;
            }
          }
          vm.save({ menu: response });
          vm.username = response.user.name;
          vm.userId = response.user.id;
          vm.userType = response.user.type;
          if (response.user.type === '1' && response.user.department && response.user.department.chat) {
            vm.department = response.user.department.id;
          }
        })
        .catch((err) => {
        });
    },
    fetchAudit(id) {
      const vm = this;
      AuditService.findfile(id)
        .then((response) => {
          if (response.processing) {
            this.$notify({
              title: 'Arquivo de auditoria processado',
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: 'Acesse a tela de de auditoria para verificar os objetos da auditoria!'
            });
            vm.$bus.$emit("audit.file.processed", id);
          } else {
            setTimeout(() => {
              vm.fetchAudit(id);
            }, 1000)
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
    },
    fetchNotifications(id) {
      const vm = this;
      UserService.notifications(id)
        .then((response) => {
          if (!response.processing) {
            this.notifications.push({ data: 'file created' });
            this.$notify({
              title: 'Arquivo gerado',
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: 'Clique no sino na parte superior ou <a href="/notifications">aqui</a> para ver o seu relatório!'
            });
          } else {
            setTimeout(() => {
              vm.fetchNotifications(id);
            }, 1000)
          }
        })
        .catch((err) => {
          vm.$message({
            type: "error",
            message: err,
          });
        });

    },
    open() {
      this.$refs.messageHighlight.open();
    },
    profile: function () {
      const vm = this;
      vm.$router.replace({ name: "profile" });
    },
    handleSelect: function (path) {
      const vm = this;
      vm.$router.push(path).catch(() => { });
    },
  },
  computed: {
    ...mapGetters("auth", ["loggedIn"]),
    subMenuList() {
      const vm = this;
      return function (item) {
        const list = {};
        for (const row of vm.menu[item]) {
          if (row.submenu) {
            list[row.submenu] = true;
          }
        }
        return list;
      };
    },
    subMenuRegister() {
      const vm = this;
      return function (name) {
        return vm.menu.register.filter(
          (data) => data.submenu && data.submenu === name
        );
      };
    },
  },
  mounted() {
    const vm = this;
    vm.me();
    if (this.$route.name === 'home') vm.open();
    vm.$bus.$on("notifications", (id) => {
      vm.fetchNotifications(id);
    });
    vm.$bus.$on("audit", (id) => {
      vm.fetchAudit(id);
    });
    vm.$bus.$on("logged", () => {
      vm.me();
    });
  },
};
</script>
<style>
/* AppHeader vive dentro do .app-topbar fixo (App.vue) — o el-header
   interno não pode ter altura/padding próprios. */
.app-topbar .el-header {
  height: auto;
  padding: 0;
}

.header-global {
  margin-bottom: 0;
}

.item-icon {
  margin-top: 0px !important;
  margin-right: 20px;
}

@media only screen and (max-width: 1218px) {
  .el-submenu__title {
    padding: 0 2px;
  }
}

@media only screen and (max-width: 1002px) {
  .el-submenu__title span {
    display: none;
  }
}

@media only screen and (max-width: 633px) {
  .mobile {
    display: flex;
  }

  .fa-2x {
    font-size: 1.5em !important;
    padding-top: 5px !important;
  }

  .logo {
    display: none !important;
  }
}

@media only screen and (min-width: 623px) {
  .mobile {
    display: none;
  }

  .logo {
    display: flex;
  }
}

.el-popover {
  box-shadow: var(--me-shadow-lg);
}
</style>
